import { localStorageUtils } from "../storageUtils";

type MasterData = Record<string, unknown>;

type MasterDataKey = "1" | "2" | "4";

const masterDataStorageKeyById: Record<MasterDataKey, string> = {
  "1": "master-data-in",
  "2": "master-data-emom",
  "4": "master-data-sea",
};

function getMasterDataForKey(key: MasterDataKey): MasterData {
  const storageKey = masterDataStorageKeyById[key];
  return (localStorageUtils.get<MasterData>(storageKey) ?? {}) as MasterData;
}

export function getMASTER_DATA(): Record<MasterDataKey, MasterData> {
  return {
    "1": getMasterDataForKey("1"),
    "2": getMasterDataForKey("2"),
    "4": getMasterDataForKey("4"),
  };
}

/**
 * Live view over master data stored in localStorage.
 * Reads from localStorage on access so it stays up-to-date.
 */
export const MASTER_DATA: Record<MasterDataKey, MasterData> = new Proxy(
  {} as Record<MasterDataKey, MasterData>,
  {
    get: (_target, prop: string | symbol) => {
      if (prop === "1" || prop === "2" || prop === "4") {
        return getMasterDataForKey(prop);
      }
      return undefined;
    },
    ownKeys: () => ["1", "2", "4"],
    getOwnPropertyDescriptor: () => ({
      enumerable: true,
      configurable: true,
    }),
  }
);
